import React, {memo} from "react"
import {MANIFEST} from "@manifest/plp"
import {useTemplatedComponent} from "@next/templating"
import {SearchApiRequestTypes} from "config/constants"
import {TextModel} from "models/Text"
import connect from "./connect"

export interface ProductsTitleProps {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children?: JSX.Element
    type: SearchApiRequestTypes
    title: string
    relaxedQuery: string
    totalResults: number
    isAutocorrected: boolean
    originalSearchTerm: string | null
    hasSelectedFilters: boolean
    overrideHeading: boolean
    text: TextModel
    enableCentreTitle: boolean
}

const ProductsTitle = memo<ProductsTitleProps>(function ProductsTitleMemo({templating, ...props}) {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName {...props} />
})

export default connect(ProductsTitle)
